import { render, staticRenderFns } from "./right-third.vue?vue&type=template&id=368d41b9&scoped=true&"
import script from "./right-third.vue?vue&type=script&lang=js&"
export * from "./right-third.vue?vue&type=script&lang=js&"
import style0 from "./right-third.vue?vue&type=style&index=0&id=368d41b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d41b9",
  null
  
)

export default component.exports